
import {Component, Vue, Ref} from 'vue-property-decorator';
import {Getter, Action, Mutation} from "vuex-class";
import {NavTabsCard, FormRowWings, SelectWings} from '@/components';
import {notifySuccess, notifyError} from "@/utils/notify-helper";
import {dateFilter} from "@/utils/date-util";
import {Duration} from 'luxon';
import { MsgTransports } from '@/store/types';
import WTab from '@/components/Tabs/WTab.vue'
import WTabs from '@/components/Tabs/WTabs.vue'
import SaveTemplate from '@/components/Templates/SaveTemplate.vue';
import SaveTemplateDialog from '@/components/Templates/SaveTemplateDialog.vue';
import Recipients from '@/components/Distributions/Recipients.vue'
import {declOfNum} from '@/utils/data-helper'
import {cloneDeep, isEqual, isEqualWith, omit, omitBy, isNil} from "lodash"
import { transformTransport } from '@/utils/download-helper';

@Component({components: {
  NavTabsCard,
  FormRowWings,
  SelectWings,
  WTab,
  WTabs,
  SaveTemplate,
  SaveTemplateDialog,
  Recipients
}})
export default class GenericDistribution extends Vue {
  @Ref('validator') validator: any;
  @Ref('template') templateRef: any;
  @Ref('recipients') recipientsRef: any;
  @Ref('pushFilter') pushFilterRef: any;

  @Getter("originators") originatorsList: any;
  @Getter("blacklists") blackLists: any;
  @Getter("messageTypes") messageTypesList: any;
  @Getter("transportsMultichannel") transportsMultichannelList: any;
  @Getter("multichannelTemplates") multichannelTemplatesList: any;
  @Getter("pushApplications") applicationsList: any;
  @Getter("allowedPages") allowedPages: any;
  @Getter("moderationSettings") moderationSettings: any;

  @Action("getTemplates") actionGetTemplates: any;
  @Action("checkAddressBookContacts") actionCheckAddressBookContacts: any;
  @Action("createDistribution") actionCreateDistribution: any;
  @Action("saveTemplate") actionSaveTemplate: any;

  @Getter("templateObject") template: any;
  @Mutation('setTemplateObject') setTemplateObject: any

  protected transport = ''

  protected activeTab = 'tab-template'
  protected templatesList = []
  step_recipients = 3;

  protected templateOrig: any = null
  protected duplicatesCount = 0
  protected totalRecipients = 0

  protected distribution: any = {
    templateId: ''
  }
  protected recipients: any = {
    groupsId: [],
    recipient: [],
  }
  protected pushFilter: any = {
    os_ids: '',
    os_version_ids: [],
    sdk_ids: [],
    mapp_ids: [],
    client_filter: null,
    device_filter: null,
  }
  recipientType = 'number' // number or filter

  isShowSaveTemplate = false
  keyName = this.$options.name || ''
  showClearButton = false
  savedData: any = null

  get distributionType() {
    return this.template.startDatetime
      ? this.$t('distribution.planned').toString() + dateFilter(this.template.startDatetime)
      : this.$t('distribution.immediate')
  }

  get distributionEnd() {
    return this.template.endDatetime
      ? dateFilter(this.template.endDatetime)
      : this.$t('distribution.notSpecified')
  }

  get distributionTime() {
    return this.template.timeBegin ?
      this.$t('distribution.distributionTime.period', {
        from: this.template.timeBegin,
        to: this.template.timeEnd
      })
      : this.$t('distribution.distributionTime.notSpecified')
  }

  get originatorName() {
    return this.originatorsList.find((item:any) => item.id == this.template.senderId)?.name
  }

  get allowedDays() {
    let days = []
    if (this.template.allowedDays.includes('MON')) days.push(this.$t('week_days.MON'))
    if (this.template.allowedDays.includes('TUE')) days.push(this.$t('week_days.TUE'))
    if (this.template.allowedDays.includes('WED')) days.push(this.$t('week_days.WED'))
    if (this.template.allowedDays.includes('THU')) days.push(this.$t('week_days.THU'))
    if (this.template.allowedDays.includes('FRI')) days.push(this.$t('week_days.FRI'))
    if (this.template.allowedDays.includes('SAT')) days.push(this.$t('week_days.SAT'))
    if (this.template.allowedDays.includes('SUN')) days.push(this.$t('week_days.SUN'))
    return days
  }

  get blackListName() {
    return this.template.blackListId
      ? this.blackLists.find((item:any) => item.id == this.template.blackListId)?.name
      : this.$t('distribution.notSelected')
  }

  get messageTypeName() {
    return this.template.messageTypeId
      ? this.messageTypesList.find((item:any) => item.messageTypeId == this.template.messageTypeId)?.messageTypeName
      : ''
  }

  get multiChannelName() {
    return this.template.multichannelId
      ? this.transportsMultichannelList.find((item:any) => item.id == this.template.multichannelId)?.name
      : ''
  }

  get multiChannelTemplateName() {
    return this.template.multichannelTemplateId
      ? this.multichannelTemplatesList.find((item:any) => item.templateId == this.template.multichannelTemplateId)?.name
      : ''
  }

  get multiChannel() {
    if (!this.template.timeout) return this.$t('distribution.multiChannel.disabled')

    // Отправить через 1 час 1 минуту 1 секунду c использованием Call-шаблона IVR
    const intervalArr = Duration.fromMillis(this.template.timeout*1000).toISOTime().split('.')[0].split(':')
    const trans = [
      this.$t('declensions.hours').toString().split('/'),
      this.$t('declensions.minutes').toString().split('/'),
      this.$t('declensions.seconds').toString().split('/'),
    ]
    const interval = intervalArr.map((data, i) => {
      const item = Number(data)
      return item ? declOfNum(item, trans[i]) : ''
    })
    return this.$t('distribution.multiChannel.enabled', {
      interval: interval.join(' '),
      channel: this.multiChannelName,
      template: this.multiChannelTemplateName
    })
  }

  get isAllowedTemplateSave() {
    return !this.distribution.templateId && this.allowedPages.includes(`menu.item.templates.${transformTransport(this.transport)}`)
  }

  get templateOnly() {
    return this.moderationSettings.find((item: any) => item.transportName == this.transport)?.templateOnly
  }

  async validateTemplateTab() {
    if (this.templateOnly) {
      if (await this.validator.validate())
        this.setActiveTab(this.distribution.templateId ? 'tab-recipients' : 'tab-message')
    } else {
      this.setActiveTab(this.distribution.templateId ? 'tab-recipients' : 'tab-message')
    }
  }

  async created() {
    try {
      this.templatesList = await this.actionGetTemplates({filter: {status: 'Active'}, transport: this.transport})
    } catch(error) {
      notifyError(error);
    }

    this.savedData = localStorage.getItem(this.keyName)
    if (this.savedData) {
      this.savedData = JSON.parse(this.savedData)
      if (this.savedData?.template) this.showClearButton = true
      if (this.savedData?.templateId) {
        this.distribution.templateId = this.savedData.templateId
      } else if (this.savedData?.template) {
        this.setTemplateObject(this.savedData.template)
        this.savedData.template = null
      }
      if (this.savedData?.recipientType) {
        this.recipientType = this.savedData.recipientType
      }
      await this.$nextTick()
      if (this.savedData?.recipients && this.recipientsRef) {
        this.recipientsRef.setState(this.savedData.recipients)
      }
      if (this.savedData?.pushFilter && this.pushFilterRef) {
        this.pushFilterRef.setState(this.savedData.pushFilter)
      }
    }
  }

  beforeLeave(to: any, from: any, next: any) {
    this.savedData = {
      templateId: this.distribution.templateId,
      template: !isEqual(this.template, this.templateRef.templateObject) ? this.template : null,
      recipientType: this.recipientType,
      recipients: this.recipientsRef ? this.recipientsRef.getState() : null,
    }
    if (this.pushFilterRef) {
      this.savedData = {...this.savedData, pushFilter: this.pushFilterRef.getState()}
    }

    localStorage.setItem(this.keyName, JSON.stringify(this.savedData))
    next()
  }

  clearSavedData() {
    localStorage.setItem(this.keyName, '')
    this.savedData = null
    this.showClearButton = false
    this.distribution.templateId = ''
    this.templateRef.setTemplate()
    this.recipientType = 'number'
    if (this.recipientsRef) this.recipientsRef.setState()
    if (this.pushFilterRef) this.pushFilterRef.setState()
  }

  onLoadTemplate(template: any) {
    this.templateOrig = cloneDeep(template)
    if (this.savedData?.template) {
      this.setTemplateObject(Object.assign(template, this.savedData.template))
      this.savedData.template = null
    }
  }

  onTemplateIdChange(val:string) {
    if (val) {
      this.templateRef.genericTemplate.getTemplate(val)
      this.step_recipients = 2
    } else {
      this.templateRef.setTemplate()
      this.step_recipients = 3
    }
  }

  setActiveTab(tab: string) {
    this.activeTab = tab
  }

  async validateTemplate() {
    if (!await this.templateRef.genericTemplate.validator.validate()) {
      notifyError(null, this.templateRef.genericTemplate.validator.errors)
      return
    }
    this.setActiveTab('tab-recipients')
  }

  async validateRecipients() {
    this.totalRecipients = this.recipientsRef.totalRecipients
    if (!await this.recipientsRef.validate()) return
    try {
      const resp = await this.actionCheckAddressBookContacts({contacts: this.recipients.recipient, groupsId: this.recipients.groupsId})
      this.duplicatesCount = resp.data.duplicatesCount
      this.setActiveTab('tab-final')
    } catch(error) {
      notifyError(error);
    }
  }

  validatePushRecipients() {
    if (this.recipientType == 'number') {
      this.validateRecipients()
    } else {
      this.setActiveTab('tab-final')
    }
  }

  async saveTemplate(name: string) {
    try {
      const template = omit(this.template, ['templateId'])
      const resp = await this.actionSaveTemplate({item: {...template, name}, transport: this.transport})
      this.distribution.templateId = resp.data.id
      this.template.templateId = resp.data.id
      this.templateOrig = cloneDeep(this.template)
      this.isShowSaveTemplate = false
      notifySuccess(this.$t('distribution.messages.templateSaved').toString())
    } catch(error) {
      notifyError(error)
    }
  }

  async createDistribution() {
    const recipients = this.recipientType == 'filter' ? this.pushFilter : this.recipients

    let template = omit(this.template, ['templateId', 'name', 'author', 'status'])
    template = omitBy(template, isNil)

    const distribution = this.distribution.templateId
      ? { templateId: this.distribution.templateId, ...recipients }
      : {...template, ...recipients}

    try {
      const resp = await this.actionCreateDistribution({distribution, transport: this.transport})
      this.clearSavedData()
      notifySuccess(this.$t('distribution.messages.distributionSaved').toString())
      this.$router.push({name: 'distribution_list'})
    } catch(error) {
      notifyError(error)
    }
  }

}
